import { useNavigate } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/images/icon/home.svg";
import { ReactComponent as Booking } from "../../assets/images/icon/booking.svg";
import { ReactComponent as My } from "../../assets/images/icon/my.svg";
import { isIOS } from "react-device-detect";

interface IProps {
    activeButton?: TGnbMenu;
    styles?: { container?: React.CSSProperties, hardDiv?: React.CSSProperties }
}
type TGnbMenu = 'home' | 'reservation' | 'my' | 'explore' | 'community';

const GnbFooter = ({ activeButton, styles }: IProps) => {
    const navigate = useNavigate();
    const isActiveButtonByValue = (value: TGnbMenu, target: 'icon' | 'caption') => {
        const isActive = activeButton === value;
        if (target === 'icon') {
            return isActive ? "var(--primaryp500)" : "var(--secondarys800)";
        }
        if (target === 'caption') {
            return isActive ? 'primary/p500' : 'secondary/s600';
        }
        return 'base/white';
    };

    return <>
        <div style={{ height: isIOS ? '106.3px' : '72.3px', ...styles?.hardDiv }} />
        <div style={{ position: "fixed", bottom: "0", width: "100%", maxWidth: "480px", zIndex: 3, ...styles?.container }}>
            <div style={{ backgroundColor: "black", display: "flex", justifyContent: "space-evenly", paddingBottom: isIOS ? 34 : 0, }} >
                <div style={{ textAlign: 'center', cursor: "pointer", padding: '12px 15px' }} onClick={() => navigate("/")}>
                    <Home width={24} height={24} fill={isActiveButtonByValue('home', 'icon')} />
                    <div className={`caption/c1 ` + isActiveButtonByValue('home', 'caption')} style={{ marginTop: '6px' }}>홈</div>
                </div>
                <div style={{ textAlign: 'center', cursor: "pointer", padding: '12px 15px' }} onClick={() => navigate("/explore")}>
                    <Booking width={24} height={24} fill={isActiveButtonByValue('explore', 'icon')} />
                    <div className={`caption/c1 ` + isActiveButtonByValue('explore', 'caption')} style={{ marginTop: '6px' }}>프로그램</div>
                </div>
                <div style={{ textAlign: 'center', cursor: "pointer", padding: '12px 15px' }} onClick={() => navigate("/my")}>
                    <My width={24} height={24} fill={isActiveButtonByValue('my', 'icon')} />
                    <div className={`caption/c1 ` + isActiveButtonByValue('my', 'caption')} style={{ marginTop: '6px' }}>MY</div>
                </div>
            </div >

        </div >
    </>
}

export { GnbFooter }